export type StatOption = { label: string; value: string; color: string; type?: "currency" }

export const statsOptions: StatOption[] = [
  { label: "stats.activeUsers", value: "activeUsers", color: "#16a34a" },
  { label: "stats.withdrawalCount", value: "withdrawalCount", color: "#f87171" },
  { label: "stats.ftdCount", value: "depositers", color: "#6b7280" },
  { label: "stats.depositCount", value: "depositCount", color: "#facc15" },
  { label: "stats.registrations", value: "userCount", color: "#4ade80" },
  { label: "stats.winsTotal", value: "win", color: "#3b82f6", type: "currency" },
  { label: "stats.betsTotal", value: "wager", color: "#eab308", type: "currency" },
  { label: "stats.ggr", value: "ggr", color: "#f97316", type: "currency" },
  { label: "stats.ftdSum", value: "ftdSum", color: "#8b5cf6", type: "currency" },
  { label: "stats.averageBet", value: "averageBet", color: "#ec4899", type: "currency" },
  { label: "stats.depositTotal", value: "deposit", color: "#14b8a6", type: "currency" },
  { label: "stats.withdrawalTotal", value: "withdrawal", color: "#f43f5e", type: "currency" },
  { label: "stats.netDeposits", value: "netDeposits", color: "#0ea5e9", type: "currency" }
]

export const cumulativeEligible = new Set([
  "deposit",
  "withdrawal",
  "wager",
  "win",
  "ggr",
  "netDeposits",
  "ftdSum",
  "depositCount",
  "withdrawalCount",
  "userCount"
])

export const currencyStats = new Set(["ggr", "deposit", "withdrawal", "netDeposits", "ftdSum", "averageBet", "win", "wager"])
